import request from '#/utils/request';
import { keysToCamel, keysToSnake } from '#/api/adapters/wireCase';

const CUSTOMER_API = '/customer/api/v1';

function customerRequest(config) {
  return request({
    baseURL: '',
    skipAuth: true,
    ...config,
    headers: {
      ...(config.headers || {}),
    },
  });
}

export async function fetchCustomerSerialTrace(serialNumber) {
  const { data } = await customerRequest({
    method: 'get',
    url: `${CUSTOMER_API}/traceability/sn/${encodeURIComponent(serialNumber)}`,
  });
  return keysToCamel(data);
}

export async function submitCustomerRepairRequest(payload, idempotencyKey) {
  const { data } = await customerRequest({
    method: 'post',
    url: `${CUSTOMER_API}/repair-requests`,
    data: keysToSnake(payload),
    headers: { 'Idempotency-Key': idempotencyKey },
  });
  return keysToCamel(data);
}

export async function fetchCustomerRepairRequest(repairRequestNo, queryCode) {
  const { data } = await customerRequest({
    method: 'get',
    url: `${CUSTOMER_API}/repair-requests/${encodeURIComponent(repairRequestNo)}`,
    headers: { 'X-Customer-Query-Code': queryCode },
  });
  return keysToCamel(data);
}

export async function fetchCustomerAttachment(path, queryCode) {
  return customerRequest({
    method: 'get',
    url: path,
    responseType: 'blob',
    headers: queryCode ? { 'X-Customer-Query-Code': queryCode } : {},
  });
}

export function buildPublicAttachmentPath({
  scope,
  serialNumber,
  repairRequestNo,
  repairItemId,
  reportId,
  fileId,
  version,
  action,
}) {
  if (!reportId || !fileId || version == null || version === '' || !action) {
    return null;
  }
  if (scope === 'inspection' || scope === 'repair') {
    if (!serialNumber) {
      return null;
    }
    const segment = scope === 'inspection' ? 'inspection-reports' : 'repair-reports';
    return [
      CUSTOMER_API,
      'traceability/sn',
      encodeURIComponent(serialNumber),
      segment,
      reportId,
      'attachments',
      fileId,
      'versions',
      version,
      action,
    ].join('/');
  }
  if (!repairRequestNo || !repairItemId) {
    return null;
  }
  return [
    CUSTOMER_API,
    'repair-requests',
    encodeURIComponent(repairRequestNo),
    'items',
    repairItemId,
    'repair-reports',
    reportId,
    'attachments',
    fileId,
    'versions',
    version,
    action,
  ].join('/');
}
